// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1923":"12e58e64","2201":"52e8a12a","6040":"12e58e64"}[chunkId] + ".chunk.css";
};